import styled from "styled-components";
import { rgba } from "polished";

export const Container = styled.div`
  background-color: ${props => props.theme.colors.bg.default};
  box-shadow: 0 1px 2px ${rgba("#000", 0.125)},
    0 16px 64px ${rgba("#000", 0.25)};
  overflow: hidden;

  &[data-placement*="top"] {
    margin-bottom: 4px;
  }
  &[data-placement*="right"] {
    margin-left: 4px;
  }
  &[data-placement*="bottom"] {
    margin-top: 4px;
  }
  &[data-placement*="left"] {
    margin-right: 4px;
  }
`;
